import { BrightdataModelStatusSchema } from "@redotech/redo-model/aeo/brightdata";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getTeamBrightdataModelStatuses = unaryRpc({
  name: "getTeamBrightdataModelStatuses",
  input: z.object({ teamId: z.string() }),
  output: z.object({ statuses: z.array(BrightdataModelStatusSchema) }),
});
